import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56bec8bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-reset-page overflow-x-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin" }

import { onBeforeUnmount, onMounted, ref } from "vue";
import ForgotPasswordHeader from "./forgotPassword/forgotPasswordHeader.vue";
import ForgotPasswordContain from "./forgotPassword/forgotPasswordContain.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'forgotPassword',
  setup(__props) {

const dyn_height = ref("0");
const windowHeight = ref("");

const onResize = () => {
  dyn_height.value = `${window.innerHeight}px`;
  windowHeight.value = `${window.innerHeight}px`;
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

onMounted(() => {
  onResize();
  window.addEventListener("resize", onResize);
  if (!document.body.classList.contains("page-opacity")) {
    onResize();
    document.body.classList.add("page-opacity", "page-bg");
  }
});

onBeforeUnmount(() => {
  beforeUnmount();
  window.removeEventListener("resize", onResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ForgotPasswordHeader, {
          "dyn-height": dyn_height.value,
          "window-height": windowHeight.value
        }, null, 8, ["dyn-height", "window-height"]),
        _createVNode(ForgotPasswordContain)
      ])
    ])
  ]))
}
}

})